import React from 'react';
import StudentDashboardLayout from '../../../layouts/gcstudent/studentdashboardLayout/StudentDashboardLayout';

import DisputesPage from '../../../subsreens/gcstudent/disputespage/DisputesPage';

const Disputes = () => {
    return(
        <StudentDashboardLayout>
            <DisputesPage></DisputesPage>
        </StudentDashboardLayout>
    )
}

export default  Disputes;